export default __webpack_public_path__ + "static/media/town.720320ec.svg";